import { Component, OnInit, Renderer2, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from '@app/shared/component/AbstractComponent';
import { AuthService } from '@app/core/auth/auth.service';
import { UserService } from '@app/core/user/user.service';
import { SpinnerService } from '@app/core/spinner/spinner.service';
import { InfoService } from '@app/core/info/info.service';
import { ResetPassword } from '../resetPassword.model';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends AbstractComponent implements OnInit, OnDestroy {

  @ViewChild('forgotButton') forgotButton: ElementRef;
  // formulario reactivo para olvido contrseña
  forgotForm: any;
  // si se ha submitido el formulario o no
  isSubmitted = false;

  constructor(
    private renderer: Renderer2,
    public authService: AuthService,
    private userService: UserService,
    private router: Router,
    private spinnerService: SpinnerService,
    private infoService: InfoService,
    public translateService: TranslateService
  ) {
    super(authService, translateService);
  }

  ngOnInit(): void {

    // podemos el estilo específico para el login
    this.renderer.addClass(document.body, 'bg-gradient-primary');
    this.renderer.addClass(document.body, 'body-image');

    // inicializamos el formulario
    this.forgotForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'bg-gradient-primary');
    this.renderer.removeClass(document.body, 'body-image');
  }

  forgot(): void {
    this.startSpinnerElement(this.forgotButton);

    this.isSubmitted = true;
    if (this.forgotForm.invalid) {
      return;
    }
    const userName = this.forgotForm.controls.userName.value;
    const email = this.forgotForm.controls.email.value;
    const resetPassword = new ResetPassword();
    resetPassword.username = userName;
    resetPassword.email = email;
    this.authService.resetPassword(resetPassword).subscribe({
      next: (forgotResponse: any) => {
        this.stopSpinnerElement(this.forgotButton);
        this.infoService.showInfo('Para cambiar la contraseña revisa tu bandeja de entrada del correo');
        void this.router.navigate(['/login']);
      },
      error: (error) => {
        if (!this.isConnectionError(error)) {
          this.errorCode = 'common.auth.login.unauthorized';
        }
        console.log('Forgot Password Error');
        this.clearForm();
        this.stopSpinnerElement(this.forgotButton);
      }
    });
  }

  clearForm(): void {
    this.forgotForm.get('userName').setValue(null);
    this.forgotForm.get('email').setValue(null);
  }
}
